module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Website_Personalize_mobile@2x-00e4ad8555ed46ffe3c94f995a782ef7.webp";